import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from './KeyImagePicker.module.scss';

const KeyImagePicker = ({
  imageUrl,
  onFileSelected,
  onRemove,
  isEditing = false,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const openFilePicker = () => {
    if (!fileInputRef.current) {
      return;
    }
    fileInputRef.current.value = '';
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const input = event.currentTarget;
    onFileSelected(event);
    input.value = '';
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.previewFrame}>
        {imageUrl ? (
          <img
            alt={t('Bild')}
            src={imageUrl}
            className={styles.image}
          />
        ) : (
          <div className={styles.emptyState}>
            {t('Kein Bild hinterlegt')}
          </div>
        )}
        {isEditing && (
          <div className={styles.actionsOverlay}>
            <button
              type="button"
              className={styles.actionButton}
              onClick={openFilePicker}
              disabled={disabled}
            >
              {t('Foto hochladen')}
            </button>
            {imageUrl && (
              <button type="button" className={styles.actionButton} onClick={onRemove} disabled={disabled}>
                {t('Entfernen')}
              </button>
            )}
          </div>
        )}
      </div>
      <input
        ref={fileInputRef}
        type="file"
        style={{ display: 'none' }}
        accept="image/*"
        onChange={handleFileChange}
        disabled={disabled}
      />
    </div>
  );
};

KeyImagePicker.propTypes = {
  imageUrl: PropTypes.string,
  onFileSelected: PropTypes.func,
  onRemove: PropTypes.func,
  isEditing: PropTypes.bool,
  disabled: PropTypes.bool,
};

KeyImagePicker.defaultProps = {
  imageUrl: null,
  onFileSelected: () => {},
  onRemove: () => {},
  isEditing: false,
  disabled: false,
};

export default KeyImagePicker;
